// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useNotify, Notification, defaultTheme } from "react-admin";
import * as React from "react";
import {
    Card, CardContent, CardActions, TextField, makeStyles, Chip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button, InputBase, Switch, InputLabel
} from '@material-ui/core';
import {transfer_form} from './index'
import { useForm ,Controller,SubmitHandler} from "react-hook-form";
// utils/validators.js
export const validateIranMobile = (value: string): boolean | string => {
    const regex = /^09\d{9}$/;
    if (value) {
      if (!regex.test(value)) {
        return "شماره موبایل صحیح نمیباشد";
      }
      return true;
    }
  };
export function TransferForm() {
    interface IFormInput {
        destMobile: string;
        sourceMobile: string;
        transferDietType:Boolean;
        transferMentor:Boolean;
      }
    const {
        register,
        handleSubmit,
         control,
        formState: { errors, isValid },
      } = useForm<IFormInput>({
        mode: "onChange",
        defaultValues: {
            destMobile: null,
          sourceMobile: null,
          transferDietType:false,
          transferMentor:false
        },
      });
    const notify = useNotify()
      const [errorMessages, setErrorMessages] = React.useState([]);
      const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");
      const onSubmit = async (data: IFormInput) => {
        setErrorMessages([]);
        setNetworkState("PENDING");
        const postData = {
            destMobile: data.destMobile,
            sourceMobile: data.sourceMobile,
            transferDietType:data.transferDietType,
            transferMentor:data.transferMentor
        };
    
        transfer_form(postData).then((res)=>{
            if (res.data.err) {
              setErrorMessages([res.data.err.details.messages[0]]);
                setNetworkState("FAILED");
            }
            else{
                if (res.data) {
                  notify("     انتقال با موفقیت انجام شد", { type: 'success' })
                  setNetworkState("SUCCESS");
                  window.location.reload()       
                }
            }
          
          }).catch((err)=>{
            console.log('err',err);
            
          })
       
    
      
        }
   
    return (
        <Card>
         
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          margin:"3rem",
          direction: "rtl",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          {...register("sourceMobile", {
            
          })}
          error={!!errors.sourceMobile}
          helperText={errors.sourceMobile ? errors.sourceMobile.message : null}
          fullWidth
          label="شماره موبایل مبدا"
          variant="outlined"
        />
       <TextField
          {...register("destMobile", {
            
          })}
          error={!!errors.destMobile}
          helperText={errors.destMobile ? errors.destMobile.message : null}
          fullWidth
          label="شماره موبایل مقصد"
          variant="outlined"
        />
            <div style={{ display: 'flex', justifyContent: 'end', width: '100%', alignItems: 'center' }}>
            <Controller
        name="transferDietType"
        control={control}
        render={({ field }) =>
        <><Switch
            {...field}
            color="primary"
            name="transferDietType"
            inputProps={{ 'aria-label': 'secondary checkbox' }} /><p style={{ fontFamily: 'IranSans-Bold', fontSize: '11px' }}> انتقال نوع  رژیم</p></>
      }
      />
   
       </div>
       <div style={{ display: 'flex', justifyContent: 'end', width: '100%', alignItems: 'center' }}>
            <Controller
        name="transferMentor"
        control={control}
        render={({ field }) =>
        <><Switch
            {...field}
            color="primary"
            name="transferMentor"
            inputProps={{ 'aria-label': 'secondary checkbox' }} /><p style={{ fontFamily: 'IranSans-Bold', fontSize: '11px' }}> انتقال   لیموپلاس</p></>
      }
      />
   
       </div>
       
        <Button
          disabled={!isValid || networkState === "PENDING"}
          fullWidth
          type="submit"
          color="primary"
          variant="contained"
        >
          انتقال
        </Button>

        {networkState === "SUCCESS" && <p>اطلاعات شما با موفقیت ثبت شد</p>}
        {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
        {networkState === "FAILED" &&
          (errorMessages.length > 0 ?   <p>{errorMessages[0]}</p> : <div>خطایی رخ داده است</div> )}
      </form>
   
        </Card >
    )
}